export default __webpack_public_path__ + "static/media/vertigo.bde5d49c.mp4";